/**
 * Mega Menu 1.0
 */
;(function ( $, window, document, undefined ) {

var megaMenu = {
    initialize: function() {
    this.setMegaMenuPosition();
    this.bindEvents();
    },

    setMegaMenuPosition: function() {
        var menuBottom = $('#main-menu')[0].getBoundingClientRect().bottom;
        $('#box-mega-menu').css('top', menuBottom + 'px');
    },

    handleResizeScroll: function() {
    if ($('.btn-mega-menu').hasClass('opened')) {
        megaMenu.setMegaMenuPosition();
    }
    },

    toggleMegaMenu: function() {
    $('#box-mega-menu').slideToggle();
    $('.btn-mega-menu').toggleClass('opened closed');

    if ($('.btn-mega-menu').hasClass('opened')) {
        this.setMegaMenuPosition();
        $('body').css('overflow', 'hidden'); // Disable background scrolling
        $('#et-main-area').css("filter", "blur(5px) brightness(0.8)");

        // Activate resize and scroll event handlers
        $(window).on('resize scroll', this.handleResizeScroll);

        // Enable outside click event to close menu
        $(document).on('click.megaMenu', this.handleOutsideClick);
    } else {
        this.closeMegaMenu();
    }
    },

    closeMegaMenu: function() {
    $('#box-mega-menu').slideUp();
    $('.btn-mega-menu').removeClass('opened').addClass('closed');
    $('body').css('overflow', ''); // Re-enable background scrolling
    $('#et-main-area').css("filter", "none");

    // Deactivate resize and scroll event handlers
    $(window).off('resize scroll', this.handleResizeScroll);

    // Disable outside click event to close menu
    $(document).off('click.megaMenu', this.handleOutsideClick);
    },

    handleOutsideClick: function(e) {
    // Close menu only if the click is outside #box-mega-menu and .btn-mega-menu
    if (!$(e.target).closest('#box-mega-menu, .btn-mega-menu').length) {
        megaMenu.closeMegaMenu();
    }
    },

    bindEvents: function() {
    var self = this;

    // Toggle menu on button click
    $('.btn-mega-menu').click(function(e) {
        e.preventDefault();
        self.toggleMegaMenu();
    });
    }
};

$(document).ready(function () {
    // Initialize the mega menu
    megaMenu.initialize();
});



})( jQuery, window, document );